export const ADD_BANNER_SUCCESS = 'ADD_BANNER_SUCCESS';
export const LIST_ALL_BANNERS_SUCCESS = 'LIST_ALL_BANNERS_REQUEST_SUCCESS';
export const UPDATE_BANNER_SUCCESS = 'UPDATE_BANNER_SUCCESS';
export const LIST_ALL_BANNERS_REQUEST = 'LIST_ALL_BANNERS_REQUEST';
export const LIST_ALL_BANNERS_FAILURE = 'LIST_ALL_BANNERS_FAILURE';
export const DELETE_BANNER_SUCCESS = 'DELETE_BANNER_SUCCESS';
export const CREATE_BANNER_SUCCESS = 'CREATE_BANNER_SUCCESS';
export const LOADING_TRUE = 'LOADING_TRUE';
export const LOADING_FALSE = 'LOADING_FALSE';
